import { Image } from './ComponentTypes'
import { Nullable } from './Opt'

type DescriptionString = {
    description: string
}

type Description = {
    data: DescriptionString
}

type Link = {
    description: Nullable<Description>
    label: string
    link: string
}

export type IconDescriptionLink = {
    name?: Nullable<string>
    url?: Nullable<string>
    description?: Nullable<string>
    tag?: Nullable<string>
    icon?: Nullable<Image>
    onClick?: () => void
}

type MenuLinkSectionsType = {
    buttonLabel: Nullable<string>
    buttonStyle: Nullable<'link' | 'button'>
    buttonUrl: Nullable<string>
    title: Nullable<string>
    link: Nullable<IconDescriptionLink[]>
    publishedAt: Nullable<string>
}

export type DynamicColumnComponentType = {
    menuLinkSections?: MenuLinkSectionsType[]
    showFooter?: Nullable<boolean>
    footerDescription?: Nullable<string>
    footerLinkLabel?: Nullable<string>
    footerLinkUrl?: Nullable<string>
    footerImage?: Nullable<Image>
    footerImageAnimation?: boolean
    lastColumnImage?: Nullable<Image>
    lastColumnImageAnimation?: boolean
    imagePosition?: Nullable<'background' | 'top'>
    imageColumnTitle?: Nullable<string>
    ImageColumnDescription?: Nullable<string>
    imageColumnLinkLabel?: Nullable<string>
    imageColumnLinkUrl?: Nullable<string>
}

export type SubMenu = DynamicColumnComponentType & {
    id: string
    strapi_component: string
    centerColumnHeader?: string
    centerColumnLinks?: Link[]
    leftColumnHeader?: string
    leftColumnLinks?: Link[]
    rightColumnHeader?: string
    rightColumnLinks?: Link[]
    leftLinks?: Link[]
    rightLinks?: Link[]
}

export type HeaderNav = {
    language: string
    link: string
    label: string
    submenu: Nullable<SubMenu[]>
    position: string
    order: number
    linkStyle?: 'link' | 'button'
}

export type Header = {
    nav: HeaderNav
}

export type SubMenuType = 'two-columns-submenu' | 'three-columns-submenu' | 'dynamic-columns'

export const subMenuType = {
    'two-columns-submenu': 'two-columns-submenu',
    'three-columns-submenu': 'three-columns-submenu',
    'dynamic-columns': 'dynamic-columns',
}

export const MapStrapiComponentToSubMenuType: Record<string, SubMenuType> = {
    'three-columns-submenu.three-columns-submenu': 'three-columns-submenu',
    'two-columns-submenu.two-columns': 'two-columns-submenu',
    'menu.dynamic-columns': 'dynamic-columns',
}
